import React from 'react'
import { graphql, Link } from 'gatsby'
import { BLOCKS, INLINES } from '@contentful/rich-text-types'
import { Divider } from '@material-ui/core'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Img from 'gatsby-image'
import SEO from '../components/SEO'
// import Layout from '../components/layout'
import Styles from './blogPost.module.scss'
import MainNav from '../components/nav'
import PreFooter from '../components/preFooter'
import Footer from '../components/footer'

const BlogPost = props => {
  const options = {
    renderNode: {
      // image embeds
      [BLOCKS.EMBEDDED_ASSET]: (node) => {
        let alt = node.data.target.fields.title['en-US']
        let url = node.data.target.fields.file['en-US'].url
        return <img className={Styles.postImg} src={url} alt={alt} />
      },
      // youtube embeds
      [INLINES.HYPERLINK]: (node) => {
        if ((node.data.uri).includes("youtube.com/embed")) {
          return (
            <span className={Styles.iframeContainer}>
              <iframe
                title="NAME_ME_LATER"
                src={node.data.uri}
                allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                frameBorder="0" allowFullScreen
              />
            </span>
          )
        } else {
          // link embeds
          return (
            <a href={node.data.uri}>{node.content[0].value}</a>
          )
        }
      },
    }
  }

  let post = props.data.contentfulBlogPost
  return (
    /*<Layout>*/
    <>
      <SEO
        title={`${post.title} - Blog | Remodelmate`}
        description={post.storySummary || post.summary.summary || 'no description available'}
        image={post.hero.file.url}
        pathname={`/${post.slug}`}
        article
        // pathname={`/blog/${post.slug}`}
      />

      <MainNav />

      <div className={Styles.blogPostContainer}>
        <div className={Styles.blogPostBackButton}>
          <Link
            to="https://blog.remodelmate.com"
          >
            ← Back to all articles
          </Link>
        </div>
        <div>
          <h1 className={Styles.blogPostH1}>{post.title}</h1>
        </div>
        <div>
          <h3 className={Styles.blogPostDate}>
            {post.publishedDate}
            {/* {post.date} */}
          </h3>
        </div>
        <div className={Styles.blogPostImgContainer}>
          <Img
            className={Styles.blogPostImg}
            fluid={post.hero.fluid}
            alt={post.hero.title}
          />
        </div>
        {/* <div>
          <p className={Styles.postDate}>{post.date}</p>
        </div> */}
        <div className={Styles.blogPostContent}>
          { 
            documentToReactComponents(post.childContentfulBlogPostBodyRichTextNode.json, options)
          }
        </div>
      </div>


      {/* <Container className={Styles.postContainer}>
        <Row className={Styles.postRow}>
          <Col className={Styles.postCol}>
            <Link
              to="https://blog.remodelmate.com"
            >
              ← Back to all articles
            </Link>
          </Col>
        </Row>
        <Row className={Styles.postRow}>
          <Col className={Styles.postCol}>
            <h1 className={Styles.postH1}>{post.title}</h1>
          </Col>
        </Row>
        <Row className={Styles.postRow}>
          <Col className={Styles.postCol}>
            <h3 className={Styles.postH3}>
              {post.publishedDate}
              {post.date}
            </h3>
          </Col>
          <Divider 
            style={{ marginBottom: "1rem" }}
          />
        </Row>
        <div className={Styles.post}>
          <Row className={Styles.postRow}>
            <Col className={Styles.postCol}>
              <Img
                className={Styles.postImg}
                fluid={post.hero.fluid}
                alt={post.hero.title}
              />
            </Col>
          </Row>
          <Row className={Styles.postRow}>
            <Col className={Styles.postCol}>
              <p className={Styles.postDate}>{post.date}</p>
            </Col>
          </Row>
          <Row className={Styles.postRow}>
            <Col className={Styles.postCol}>
              {
                documentToReactComponents(post.childContentfulBlogPostBodyRichTextNode.json, options)
              }
            </Col>
          </Row>
        </div>
      </Container> */}

    <PreFooter />

      <Footer />
    </>
    /*</Layout>*/
  )
}
export default BlogPost

export const query = graphql`
  query ($slug: String!) {
    contentfulBlogPost(slug: { eq: $slug }) {
      title
      publishedDate(formatString: "MMMM Do, YYYY")
      hero {
        fluid (maxWidth: 1056, maxHeight: 704) {
          ...GatsbyContentfulFluid
        }
        title
      }
      childContentfulBlogPostBodyRichTextNode {
        json
      }
      storySummary
      summary {
        summary
      }
      hero {
        file {
          url
        }
      }
      slug
    }
  }
`